import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "paging_links"
}
const _hoisted_2 = { "aria-label": "Paging" }
const _hoisted_3 = { class: "pagination pagination-sm" }
const _hoisted_4 = {
  key: 0,
  class: "pagination-text"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["title", "data-testid", "onClick"]
const _hoisted_7 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.totalPages > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            (_ctx.$slots['prefix'])
              ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "prefix", {}, undefined, true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", {
              class: _normalizeClass({ disabled: !_ctx.hasPreviousButton || _ctx.disabled })
            }, [
              _createElementVNode("a", {
                href: "#",
                title: "Previous Page",
                class: _normalizeClass(_ctx.navigationClass),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.modelValue - 1)), ["prevent"]))
              }, [
                _renderSlot(_ctx.$slots, "prevPage", {}, () => [
                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "glyphicon glyphicon-arrow-left" }, null, -1))
                ], true)
              ], 2)
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageList, (page, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: page.page + '/' + index,
                class: _normalizeClass({
            [_ctx.skipClass]: page.skip,
            active: page.page === _ctx.modelValue,
            disabled: _ctx.disabled,
          })
              }, [
                (page.skip)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _renderSlot(_ctx.$slots, "skip", {}, () => [
                        _cache[3] || (_cache[3] = _createTextVNode("…", -1))
                      ], true)
                    ]))
                  : (page.page !== _ctx.modelValue)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "#",
                        class: _normalizeClass(_ctx.navigationClass),
                        title: 'Page ' + page.page,
                        "data-testid": `pagination-page-${page.page}`,
                        onClick: _withModifiers(($event: any) => (_ctx.changePage(page.page)), ["prevent"])
                      }, _toDisplayString(page.page), 11, _hoisted_6))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: _normalizeClass(_ctx.navigationClass),
                        title: 'Page ' + page.page,
                        "data-testid": "pagination-current-page"
                      }, _toDisplayString(page.page), 11, _hoisted_7))
              ], 2))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass({ disabled: !_ctx.hasNextButton || _ctx.disabled })
            }, [
              _createElementVNode("a", {
                href: "#",
                class: _normalizeClass(_ctx.navigationClass),
                title: "Next Page",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.modelValue + 1)), ["prevent"]))
              }, [
                _renderSlot(_ctx.$slots, "nextPage", {}, () => [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "glyphicon glyphicon-arrow-right" }, null, -1))
                ], true)
              ], 2)
            ], 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}